import { withFormik } from 'formik';
import PropTypes from 'prop-types';
import ResetPasswordFormLayout from './layout';
import { validateFields } from '../../../utility/validation';
import fields from './fields';
import { isObjectEmpty } from '../../../utility/helpers';

const ResetPasswordFormWithFormik = withFormik({
  mapPropsToValues: () => ({ password: '', repeatPassword: '' }),
  validate: async values => {
    const errors = await validateFields(fields, values);

    if (
      isObjectEmpty(errors) &&
      values.password &&
      values.repeatPassword &&
      values.password !== values.repeatPassword
    ) {
      errors.password = 'passwordMismatch';
      errors.repeatPassword = 'passwordMismatch';
    }

    throw errors;
  },
  validateOnBlur: false,
  handleSubmit: (values, { props, setSubmitting }) => {
    props.handleSubmitHandler(values, props, setSubmitting);
  },
})(ResetPasswordFormLayout);

const ResetPasswordForm = ({ withoutBackLink = false, ...props }) => (
  <ResetPasswordFormWithFormik withoutBackLink={withoutBackLink} {...props} />
);

ResetPasswordForm.propTypes = {
  translations: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
  handleSubmitHandler: PropTypes.func.isRequired,
  withoutBackLink: PropTypes.bool,
};

export default ResetPasswordForm;
